import { currencyLabel } from '../lib/currency';

/**
 * What a Journal task pays, mirrored from `content/packs/core.v1/{daily,weekly}_tasks/*.json` —
 * `JournalTaskDto` carries no reward, and the QA pass (2026-09-23, progress F11) found the Journal
 * naming no amount anywhere: six ticks, three bars labelled "Motes", and an all-dailies bonus that
 * lands unannounced (Hide the empty #14.4/2026-09-27 has since retired the Mote grant itself --
 * the three weekly bars all pay Shells now). Same content-mirror idiom as `companion/speciesCatalog.ts`;
 * `taskRewards.contentDrift.test.ts` fails the moment the pack and this table disagree (and reads
 * the bonus straight out of `JournalService.java`, its only source of truth).
 */
export type TaskReward = { currency?: string; amount?: number; xp?: number };

export const DAILY_REWARD: TaskReward = { currency: 'shells', amount: 100, xp: 20 };

export const WEEKLY_REWARDS: Record<string, TaskReward[]> = {
  weekly_dailies: [{ currency: 'shells', amount: 150 }, { xp: 150 }],
  weekly_forage: [{ currency: 'shells', amount: 100 }, { xp: 150 }],
  weekly_quests: [{ currency: 'shells', amount: 500 }, { xp: 150 }],
};

/** `JournalService.ALL_FIVE_BONUS_XP` — granted once, the moment the last daily of the day lands. */
export const ALL_DAILIES_BONUS_XP = 40;

/** "100 Shells · 20 XP" — one reward line, in the order the content lists them. */
export function rewardLine(rewards: TaskReward[]): string {
  return rewards.map((r) => (r.xp != null ? `${r.xp} XP` : `${r.amount} ${currencyLabel(r.currency ?? '')}`)).join(' · ');
}
